import Subtitle from 'components/TextComps/Subtitle';
import { useServices } from 'index';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { isPastDate } from 'utilities/isPastDate';
import { EventTile } from '../EventTile/EventTile';
import { NoUpcomingEvents } from '../NoUpcomingEvents/NoUpcomingEvents';
import { EventTileSkeleton } from '../EventTileSkeleton/EventTileSkeleton';
import { useMemo } from 'react';

export const UpcomingEventsNew = () => {
  const { t } = useTranslation();

  const trackmanEventsService = useServices().trackmanEventsService;
  const profileService = useServices().profileService;

  const trackmanEventsList = useQuery({
    queryKey: ['trackmanEventsList'],
    queryFn: trackmanEventsService.getTrackmanEvents,
    refetchOnWindowFocus: false,
  });

  const isUserMember = useQuery({
    queryKey: ['isUserMember'],
    queryFn: profileService.checkIfUserIsMember,
    refetchOnWindowFocus: false,
  });

  const upcomingEvents = useMemo(() => trackmanEventsList.data?.events.filter((event) => !isPastDate(event.startDate)) || [], [trackmanEventsList.data]);

  return (
    <div className='events-subpage'>
      <div className='page-heading'>
        <Subtitle>
          <>{t('UpcomingEvents', { ns: 'trackmanEvents' })}</>
        </Subtitle>
      </div>
      {trackmanEventsList.isPending && isUserMember.isPending ? (
        Array.from(Array(10)).map((el, index) => <EventTileSkeleton key={index} />)
      ) : upcomingEvents.length ? (
        <div className='events-list'>
          {upcomingEvents.map((event, i) => (
            <EventTile key={`${event.title}+${i}`} eventItem={event} isUserMember={isUserMember.data} />
          ))}
        </div>
      ) : (
        <NoUpcomingEvents />
      )}
    </div>
  );
};
